import {cloneDeep as _cloneDeep} from 'lodash';
import PlanningModel from "./../../models/PlanningModel"

const PlanningsModule = {
    namespaced: true,
    state: () => ({
        plannings: [],
        planning: _cloneDeep(PlanningModel, true),
        participantRoles: [],
    }),
    getters: {
        getPlannings(state) {
            return state.plannings
        },
        getPlanning(state) {
            return state.planning
        },
        getParticipantRoles(state) {
            return state.participantRoles
        },
    },
    mutations: {
        setPlannings(state, payload) {
            state.plannings = payload
        },
        setPlanning(state, payload) {
            state.planning = payload
        },
        setParticipantRoles(state, payload) {
            state.participantRoles = payload
        },
    },
    actions: {
        setPlannings(context, payload) {
            context.commit('setPlannings', payload);
        },
        setPlanning(context, payload) {
            context.commit('setPlanning', payload);
        },
        setParticipantRoles(context, payload) {
            context.commit('setParticipantRoles', payload);
        },
    },
}

export default PlanningsModule;
